import i18next from 'i18next';

import { ORDER_TYPE } from '~constants/orders';

i18next.addResources('es_CL', 'OrdersType', {
  [ORDER_TYPE.SCHEDULED]: 'Futura',
  [ORDER_TYPE.DEFERRED]: 'Diferido',
  [ORDER_TYPE.DEFAULT]: ''
});

i18next.addResources('es_CR', 'OrdersType', {
  [ORDER_TYPE.SCHEDULED]: 'Futura',
  [ORDER_TYPE.DEFERRED]: 'Diferido',
  [ORDER_TYPE.DEFAULT]: ''
});
